<template>
  <detail-item
    name="Signing Info"
    imgName="circle">
    <div v-if="signingInfo.status == 0" class="vertical">
      <span class="attr">
        Signer Type: {{
        getEnumString($typeDefs.types.signing.fields,
        'signerType',
        signingInfo.signerType) }}
      </span>
      <span v-if="signingInfo.teamid" class="attr">Team ID: {{ signingInfo.teamid }}</span>
      <span v-if="signingInfo.appid" class="attr">App ID: {{ signingInfo.appid }}</span>
      <span v-if="signingInfo.entitlements.length > 0" class="attr">
        Entitlements: {{ signingInfo.entitlements.join(', ') }}
      </span>
      <span v-if="signingInfo.authorities.length > 0" class="attr">
        Authorities: {{ signingInfo.authorities.join(' → ') }}
      </span>
    </div>
    <div v-else>
      <a
      :href="`https://www.osstatus.com/search/results?platform=all&framework=all&search=${signingInfo.status}`"
      target="_blank">
      <span v-if="signingInfo.statusMessage">
        Error: {{ signingInfo.statusMessage }} ({{ signingInfo.status }})
      </span>
      <span v-else>
        Error {{ signingInfo.status }}
      </span>
      </a>
    </div>
  </detail-item>
</template>

<script>
import alertlog from '@/mixins/alertlog';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'AlertLogSigningInfo',
  mixins: [alertlog, gmt],
  components: {
    DetailItem,
  },
  props: {
    signingInfo: {
      type: Object,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical {
  display: flex;
  flex-direction: column;
}

.attr {
  width: 100%;
}
</style>
